<template>
  <section :class="$style.shopConfigurationHeader">
    <span :class="$style.shopHeader">{{ props.configData.name }}</span>
  </section>
  <section :class="$style.shopConfiguration">
    <div v-for="section in props.configData.sections" :key="section.id">
      <DataTable :value="section.purchasable">
        <template #header>
          <span>{{ section.name }}</span>
        </template>
        <Column field="name" header="Name" :header-class="$style.columnHeader" />
        <Column field="reward" header="Reward" :header-class="$style.columnHeader">
          <template #body="rowProps">
            <div v-for="item in rowProps.data.reward.items" :key="`${rowProps.data.reward.id}-${item.name}`">
              {{ item.quantity }} {{ item.name }}
            </div>
          </template>
        </Column>
        <Column field="price" header="Price" :header-class="$style.columnHeader">
          <template #body="rowProps">
            <div v-if="rowProps.data.price.type === 'IAP'">
              <Chip :class="$style.priceBadge" :label="rowProps.data.price.appleProductId" icon="pi pi-apple" />
              <Chip :class="$style.priceBadge" :label="rowProps.data.price.androidProductId" icon="pi pi-google" />
            </div>
            <span v-if="rowProps.data.price.type === 'REWARD_VIDEO'">{{ rowProps.data.price.amount }} RV</span>
            <span v-if="rowProps.data.price.type === 'VIRTUAL_CURRENCY'">
              {{ rowProps.data.price.amount }} {{ rowProps.data.price.currencyType }}
            </span>
            <span v-if="rowProps.data.price.type === 'FREE'">Free</span>
          </template>
        </Column>
      </DataTable>
    </div>
  </section>
</template>
<script setup lang="ts">
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import Chip from "primevue/chip";
import { SimulationShop } from "@/modules/Simulation/types";

const props = defineProps<{
  configData: SimulationShop;
}>();
</script>
<style module lang="scss">
.shopConfigurationHeader .shopHeader {
  font-size: 16px;
  display: block;
  margin: 10px 10px 10px 0;
  font-weight: 600;
  color: $intense-blue;
}
.shopConfiguration {
  .p-datatable-header {
    border-radius: 0.5rem 0.5rem 0 0;
    border-width: 1px;
  }

  .p-datatable-table {
    border: 1px solid #e5e7eb;
    border-width: 0 1px 0 1px;
    border-radius: 0 0 0.5rem 0.5rem;

    .columnHeader {
      background: #f9fafb;
    }
  }

  .p-datatable-table > tbody > tr:last-of-type > td:first-of-type {
    border-radius: 0 0 0 0.5rem !important;
  }

  .p-datatable-table > tbody > tr:last-of-type > td:last-of-type {
    border-radius: 0 0 0.5rem 0 !important;
  }

  .priceBadge {
    margin: 5px;
  }
}
</style>
